import { IAuditBase } from "./shared";

export enum USER_STATUS {
  /**
   * Can log in and function as normal
   */
  ACTIVE = "Active",
  /**
   * Initial account has been created, but still needs some onboarding info
   */
  ONBOARDING = "Onboarding",
  /**
   * Invite has been sent to the user but no account has been created yet
   */
  INVITE_PENDING = "InvitePending"
}

export enum USER_TYPE {
  PORTAL = "Portal",
  DANCER = "Dancer"
}

export interface IUser extends IAuditBase {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  status: USER_STATUS;
}

export interface IUpdateSelfRequest {
  firstName: string;
  lastName: string;
}